// @todo роутинг
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getIdByStorage } from 'reactApp/modules/storage/storage.helpers';
import { EStorageType } from 'reactApp/modules/storage/storage.types';

const testPath = (path) => /^\/search$|^\/search\//.test(path);

export const useFallbackSearchUrl = (defaultPath) => {
    const locationBeforeSearch = useRef({ pathname: testPath(defaultPath) ? getIdByStorage(EStorageType.home) : defaultPath, search: '' });
    let location = {
        pathname: defaultPath,
        search: '',
    };

    // для случаев рендера вне контекста react-router
    try {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        location = useLocation();
    } catch (err) {}

    const { pathname, search } = location;

    useEffect(() => {
        const isSearchLocation = testPath(pathname);
        if (!isSearchLocation) {
            locationBeforeSearch.current = { pathname, search };
        }
    }, [pathname, search]);

    return locationBeforeSearch;
};
